<template>
    <div class="container-fluid"  >
        <label><input type="checkbox" class="form-check-input" v-model="boost"/>Weather Boost</label>
        <div class="row">
            <div class="col attack_table">
                <AttackInfo v-if="fastAttack" :attack="fastAttack" :energy="energy"/>
            </div>
            <div class="col attack_table">
                <AttackInfo  v-if="ch1Attack" :attack="ch1Attack" :energy="energy"/>
            </div>
            <div class="col attack_table">
                <AttackInfo  v-if="ch2Attack" :attack="ch2Attack" :energy="energy"/>
            </div>

        </div>
        <div class="row">

        </div>
        <div class="row">

        </div>
    </div>
</template>

<script>
    import {damage, effectivity, stats} from "../../../helpers/pokemon_calc.js";
    import {pokemon_data, types} from "../../../helpers/pokemon_data.js";
    import AttackInfo from "./AttackInfo";
    import {hp} from "../../../helpers/pokemon_calc";
    import {combat_setting} from "../../../helpers/pokemon_data";

    export default {
        name: "BattleInfo",
        components: {AttackInfo},
        props:['attacker','defender','pvp'],
        data: function () {
            return {
                boost: false,
                energy: 0,
                // fast: this.attackinfo(0),
                // charge1: this.attackinfo(1),
                // charge2: this.attackinfo(2),
            };
        },
        methods: {
            attackinfo: function (ix) {
                // console.log(ix);
                if (this.attacker.id === undefined) return null;
                if (this.defender.id === undefined) return null;
                if (this.attacker.moves === undefined) return null;
                let move = this.attacker.moves[ix];
                // console.log(move);
                if(move===null){
                    return null;
                }
                if(move.move_id===undefined){
                    return null;
                }
                let currStats = stats(this.attacker.id, this.attacker.level, this.attacker.ivs);
                let deffStats = stats(this.defender.id, this.defender.level, this.defender.ivs);
                let aTypes = pokemon_data[this.attacker.id][4];
                let dTypes = pokemon_data[this.defender.id][4];
                let move_type_id = types.indexOf(move.type);
                let STAB = aTypes.indexOf(move_type_id) >= 0 ? 1.2 : 1.0;
                // debugger // eslint-disable-line
                let eff = effectivity(dTypes, move.type);
                let wBoost = this.boost ? combat_setting.sameTypeAttackBonusMultiplier : 1.0;
                let pvp = this.pvp ? (ix > 0 ? combat_setting.chargeAttackBonusMultiplier : combat_setting.fastAttackBonusMultiplier) : 1.0;
                // TODO multiplier charge attack Excelent,Greate, ...
                // debugger // eslint-disable-line
                let damagePerHit = damage(currStats[0], deffStats[1], move.power, STAB * eff * wBoost * pvp);
                let hits = Math.ceil(deffStats[2] / damagePerHit);
                let energyGain = hits*move.energy_delta;
                let timeToUse = 0;
                let tapsToCharge = 0;
                let posibleUses = 0;
                let hp_left_first = 0;
                let hp_left_second = 0;
                let hp_left_third = 0;
                let hp_left_with_shield_first = 0;
                let hp_left_with_shield_second = 0;
                let hp_left_with_shield_third = 0;
                let time_after_first = 0;
                let time_after_second = 0;
                let time_after_third = 0;
                if(ix==0){
                    this.energy = energyGain;
                }
                if(ix>0){
                    let fmove =this.attacker.moves[0];
                    // debugger // eslint-disable-line
                    timeToUse = Math.ceil(Math.abs(move.energy_delta)/fmove.energy_delta) * fmove.duration / 1000.0;
                    tapsToCharge = Math.abs(move.energy_delta)/fmove.energy_delta;
                    posibleUses = Math.floor(this.energy /Math.abs( move.energy_delta));

                    hp_left_first = hp(this.defender.id, this.defender.level, this.defender.ivs) - (tapsToCharge * this.fastAttack.damage + damagePerHit);
                    hp_left_second = hp_left_first - (tapsToCharge * this.fastAttack.damage + damagePerHit);
                    hp_left_third = hp_left_second - (tapsToCharge * this.fastAttack.damage + damagePerHit);

                    hp_left_with_shield_first= hp(this.defender.id, this.defender.level, this.defender.ivs) - (tapsToCharge * this.fastAttack.damage);
                    hp_left_with_shield_second= hp_left_with_shield_first - (tapsToCharge * this.fastAttack.damage);
                    hp_left_with_shield_third= hp_left_with_shield_second - (tapsToCharge * this.fastAttack.damage  + damagePerHit);

                    time_after_first = Math.ceil((fmove.duration*tapsToCharge)/1000);
                    time_after_second = Math.ceil((fmove.duration*tapsToCharge*2+move.duration)/1000);
                    time_after_third = Math.ceil((fmove.duration*tapsToCharge*3+2*move.duration)/1000);
                }
                return {
                    name: move.name,
                    power: move.power,
                    duration: move.duration,
                    damage: damagePerHit,
                    hits:  hits,
                    chargeTime:timeToUse,
                    energyGain: energyGain,
                    energyDelta: move.energy_delta,
                    tapsToCharge: tapsToCharge,
                    posibleUses: posibleUses,
                    hp_left_first: hp_left_first,
                    hp_left_second: hp_left_second,
                    hp_left_third: hp_left_third,
                    hp_left_with_shield_first: hp_left_with_shield_first,
                    hp_left_with_shield_second: hp_left_with_shield_second,
                    hp_left_with_shield_third: hp_left_with_shield_third,
                    time_after_first:time_after_first ,
                    time_after_second:time_after_second,
                    time_after_third:time_after_third ,
                }
            },
        },
        computed: {
            fastAttack: function () {
                // debugger // eslint-disable-line
                return this.attackinfo(0);
            },
            ch1Attack: function () {
                // debugger // eslint-disable-line
                return this.attackinfo(1);
            },
            ch2Attack: function () {
                // debugger // eslint-disable-line
                return this.attackinfo(2);
            },
        },
    }
</script>

<style scoped>
    .attack_table {
        padding-left: 0;
        padding-right: 0;
    }
</style>